var Shopify = Shopify || {};
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
if($('body').hasClass('template-cart')){
  Shopify.Cart.ShippingCalculator.show( {
    submitButton: theme.strings.shippingCalcSubmitButton,
    submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
    customerIsLoggedIn: theme.strings.shippingCalcCustomerIsLoggedIn,
    moneyFormat: theme.strings.shippingCalcMoneyFormat
  });
}
function discount(){
    const totalDisc = document.querySelectorAll('.saso-total-discount');
    const klarna = document.querySelector('#klarna-installment');
    const laybuy = document.querySelector('#laybuy-installment');
    const bodyEl = document.querySelector('body');
    const sasoCartTotal = document.querySelector('.saso-cart-total');
    const total = parseInt(sasoCartTotal.getAttribute('data-total'));
    const totalText = Number(sasoCartTotal.textContent.replace(/[^0-9.-]+/g,""));
    if(klarna){
      klarna.innerHTML = Shopify.formatMoney(totalText * 100 / parseInt(klarna.getAttribute('data-installment')), bodyEl.getAttribute('data-money'));
    }
    if(laybuy){
      laybuy.innerHTML = Shopify.formatMoney(totalText * 100 / parseInt(laybuy.getAttribute('data-installment')), bodyEl.getAttribute('data-money'));
    }
    var interval = setInterval(function() {
      if (saso.discounts) {
        clearInterval(interval);
        if(totalDisc && saso.discounts.total_discount_amount_html){
          totalDisc.forEach((el) => {
            el.innerHTML = saso.discounts.total_discount_amount_html;
            el.parentNode.classList.remove('hidden');
          });
        }
        // Try bundler discounts 
        if(klarna && saso.discounts.total_discount_amount_html){
          klarna.innerHTML = Shopify.formatMoney(saso.discounts.discounted_price * 100 / parseInt(klarna.getAttribute('data-installment')), bodyEl.getAttribute('data-money'));
        }
        if(laybuy && saso.discounts.total_discount_amount_html){
          laybuy.innerHTML = Shopify.formatMoney(saso.discounts.discounted_price * 100 / parseInt(laybuy.getAttribute('data-installment')), bodyEl.getAttribute('data-money'));
        }
      }
    }, 200);
}

$(document).ready(function(){
  $(document).on('click','.open-variants',function(){
    $(this).toggleClass('opened');
    const variantGroup = $(this).siblings('.variants-group');
    if($(this).hasClass('opened')){
      $(this).text('Close');
      let height = 0;
      variantGroup.children().each(function(){
        height += $(this).height() + 10;
      })
      variantGroup.height(height);
    }else{
      $(this).text('Choose options');
      variantGroup.height(0);
    }
  });

  $(document).on('click','.open-account-popup',function(){
    $('.side-popup').removeClass('visible');
    $('.cart-drawer-wrapper').removeClass('active');
    $('body').removeClass('overflow-hidden');
    $('#account-popup').addClass('visible');
    $('#account-popup').find('.customer').hide();
    const section = $(this).attr('data-target');
    $('#account-popup').find(`.customer.${section}`).show();
  });
  $(document).on('click','.recover-toggle',function(){
    $(this).parents('.customer').hide();
    $(this).parents('.customer').siblings('.recover').show();
  })
  $(document).on('click','.login-toggle',function(){
    $(this).parents('.customer').hide();
    $(this).parents('.customer').siblings('.login').show();
  })
  $(document).on('click','.signup-toggle',function(){
    $(this).parents('.customer').hide();
    $(this).parents('.customer').siblings('.register').show();
  })
  function formToJSON(elements) {
    return [].reduce.call(elements, function (data, element) {
      data[element.name] = element.value;
      return data;
    }, {});
  }
  function getUrlString(data) {
    var urlParameters = Object.entries(data).map(function (e) {
      return e.join('=');
    }).join('&');
  
    return urlParameters;
  } 
  $('#sidebar-recover').on('submit',function(event){
    event.preventDefault();
    const form = $(this);
    const action = form.attr("action");
    const inputs = form[0].querySelectorAll("[name]");
    fetch(action, {
			method: 'POST',
			body: getUrlString(formToJSON(inputs)),
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				'Accept': 'text/html, */*; q=0.01',
				'X-Requested-With': 'XMLHttpRequest'
			}
		}).then(function(response) {
      form.parents('.recover-form-wrapper').hide();
      form.parents('.recover-form-wrapper').siblings('.recover-success').html(`
        <p>Password reset link has been sent to your email. Please go back to login</p>
        <button type="button" class="login-toggle">Login</button>
      `)
		}).catch(function(err) {
			console.error(err);
		});
    
  })
  $(document).on('click','[href="#recover"]',function(){
    $('#recover').show();
    $('#login').hide();
  });$(document).on('click','[href="#login"]',function(){
    $('#login').show();
    $('#recover').hide();
  });

  $(document).on('click','#checkout-trigger',function(){
    $(this).attr('disabled','disabled').css('opacity','0.6');
    $('#checkout').trigger('click');
  });

  $(document).on('click','.delivery-calculator',function(){
    $('#shipping-calculator-popup').addClass('visible')
  });

  $(document).on('click','.popup-close,.popup-overlay',function(){
    $(this).parents('.side-popup').removeClass('visible');
  });


  $(document).on('click','.edit-variants',function(event){
    event.stopPropagation();
    $(this).toggleClass('opened');
    const variantGroup = $(this).siblings('.variants-group');
    if($(this).hasClass('opened')){
      $(this).text('Close');
      let height = 0;
      variantGroup.children().each(function(){
        height += $(this).outerHeight();
      })
      variantGroup.outerHeight(height);
    }else{
      $(this).text('Edit');
      variantGroup.height(0);
    }
  });

  $(document).on('click','.age-verification,#checkout-filter',function(e){
    e.preventDefault();
    $('#age-verification-popup').addClass('visible');
  });

  $(document).on('change','#age-checkbox',function(){
    const selects = $(this).parents('.age-section').find('select');
    if($(this).is(':checked')){
      selects.removeAttr('disabled');
    }else{
      selects.attr('disabled','disabled');
    }
  })

  function calcDate(date1,date2) {
    var diff = Math.floor(date1.getTime() - date2.getTime());
    var day = 1000 * 60 * 60 * 24;

    var days = Math.floor(diff/day);
    var months = Math.floor(days/31);
    var years = Math.floor(months/12);

    return years
  }

  $(document).on('click','#age-confirm',function(){
    var date = $('select[name=age-day]').val();
    var year = $('select[name=age-year]').val();
    var month = $('select[name=age-month]').val();
    const birthDate = new Date(year, month, date);
    const now = new Date();
    const diff = calcDate(now,birthDate) + 1;
    if(diff < 18){
      $(this).after('<span class="age-error">You must be 18+ years old to checkout</span>')
    }else{
      $(this).next('span').remove();
      $('#checkout-filter').addClass('hidden');
      $('#checkout').removeClass('hidden');
      $('#main-cart-footer').find('.age-verification').addClass('hidden');
      $('#age-verification-popup').removeClass('visible');
    }
  })

  $('select[name=age-month]').on('change', function(){
    checkTotalDay();
  });
  $('select[name=age-year]').on('change', function(){
      checkTotalDay();
  });

  function checkTotalDay() {
      const year = $('select[name=age-year]').val();
      const month = $('select[name=age-month]').val();
      let currentSelected = $('select[name=age-day]').find('option:selected').val();
      let totalDate = 31;
      if(year !== '' && month !== '') {
          totalDate = new Date(year, parseInt(month)+1, 0).getDate();
      }
      $('select[name=age-day]').empty();
      for(var i = 1; i <= totalDate; i++) {
        $('select[name=age-day]').append("<option value='"+i+"'>"+i+"</option>");
      }
      if(currentSelected > totalDate){
        $('select[name=age-day]').val(totalDate).change();
      }else{
        $('select[name=age-day]').val(currentSelected).change();
      }
  }

  $(document).on('click','.change-variant-atc:not(.disabled):not(.soldout)',function(e){
    document.querySelector('.cart__checkout-button').disabled = true
    e.preventDefault();
    e.stopPropagation();

    const vid = parseInt($(this).attr('data-variant-id'));
    const originalVariantId = parseInt($(this).attr('data-original-id'));
    let qty = parseInt($(this).parents('.cart-item').find('.quantity__input').val());
    const max = parseInt($(this).attr('data-max-qty'));
    qty = (qty > max) ? max : qty;
    const removeBtn = $(this).parents('.cart-item').find('cart-remove-button');
    
    const mainCartItems = $(this).parents('#main-cart-items');
    mainCartItems.addClass('cart__items--disabled');
    const cartParents = $(this).parents('.cart-item').index() + 1;
    const cartItemElements = $(`#CartItem-${cartParents} .loading-overlay`);
    const cartDrawerItemElements = $(`#CartDrawer-Item-${cartParents} .loading-overlay`);
    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));
    $(this).parents('.change-variants-wrapper').find('.edit-variants').trigger('click');
    $('#shopping-cart-line-item-status').attr('aria-hidden', false);

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: qty,
        id: vid
      },
      dataType: 'json', 
      success: function (data) {
        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: {
            quantity: 0,
            id: originalVariantId
          },
          dataType: 'json', 
          success: function (data) {
            document.querySelector('.cart__checkout-button').disabled = false
            setTimeout(function() {
              window.location.reload();
            }, 1800);
          },
          error: function (data) {
           setTimeout(function() {
             window.location.reload();
           }, 1800);
         }
        });
      },
      error: function (data) {
        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: {
            quantity: 0,
            id: originalVariantId
          },
          dataType: 'json', 
          success: function (data) {
            setTimeout(function() {
              window.location.reload();
            }, 1800);
          },
          error: function (data) {
           document.querySelector('.cart__checkout-button').disabled = false
           setTimeout(function() {
             window.location.reload();
           }, 1800);
         }
        });
     }
    });
       
  });

  let scrollTimeout = '';
  $(document).on('scroll',function(){
    if($('.cart-drawer-wrapper.added-to-cart').length){
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        $('.cart-drawer-wrapper.added-to-cart').find('.drawer__close').trigger('click');
      }, 500);
    }
    if($('body').hasClass('template-cart')){
      if($(this).scrollTop() >= $('.row.cart-header').offset().top + $('.row.cart-header').outerHeight() && $(this).scrollTop() + $(window).height() <= $('#checkout').offset().top) {
        $('.row.cart-title').prev().css('margin-bottom',$('.row.cart-title').outerHeight());
        $('.row.cart-title').addClass('fixed');
      }else{
        $('.row.cart-title').prev().css('margin-bottom',0);
        $('.row.cart-title').removeClass('fixed');
      }
    }
    
  });
  
  if($('body').hasClass('template-cart')){
    tick();
    discount();
  }

  const addressSlider = new Swiper('.address-blocks', {
    slidesPerView: 4,
    spaceBetween: 30,
    draggable: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      320: {
        slidesPerView: 1.3
      },
      640: {
        slidesPerView: 2
      },
      768: {
        slidesPerView: 3
      },
      1200: {
        slidesPerView: 4
      }
    }
  });
  $(document).on('click','.add-address',function(){
    $('.side-popup').removeClass('visible');
    $('#add-address').addClass('visible');
  });
  $(document).on('click','.edit-address',function(){
    $('.side-popup').removeClass('visible');
    $('#edit-address').addClass('visible');
    const id = $(this).parents('.address-block').attr('data-id');
    $('#edit-address').find('.edit-form').hide();
    const activeForm = $('#edit-address').find(`.edit-form#address_form_${id}`);
    activeForm.show();
    if(activeForm.find('[name="address[default]"]').attr('type') === 'hidden'){
      activeForm.find('[name="address[default]"]').attr('type','checkbox');
    }
  });

  $(document).on('submit','#address_form_new',function(event){
    event.preventDefault();
    const form = $(this);
    const action = form.attr("action");
    const inputs = form[0].querySelectorAll("[name]");
    const JSONData = formToJSON(inputs);
    form.addClass('disabled');
    fetch(action, {
			method: 'POST',
			body: getUrlString(JSONData),
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				'Accept': 'text/html, */*; q=0.01',
				'X-Requested-With': 'XMLHttpRequest'
			}
		}).then(response=>response.text()).then(function(data) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, "text/html");
      const bodyEl = doc.body;
      const addressList = bodyEl.querySelector('#address-list');
      const newSlides = addressList.querySelectorAll('.address-block');
      const editForm = bodyEl.querySelector('#address-edit').innerHTML;
      addressSlider.removeAllSlides();
      newSlides.forEach(function(c,i){
        addressSlider.appendSlide(c);
      });
      $('#editFormContainer').empty().append(editForm);
      $('#add-address').removeClass('visible');
      form.trigger("reset");
      form.removeClass('disabled');
		}).catch(function(err) {
			console.error(err);
		});
    
  })

  $(document).on('submit','form.edit-form',function(event){
    event.preventDefault();
    const form = $(this);
    const action = form.attr("action");
    const inputs = form[0].querySelectorAll("[name]");
    const JSONData = formToJSON(inputs);
    form.addClass('disabled');
    fetch(action, {
			method: 'POST',
			body: getUrlString(JSONData),
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				'Accept': 'text/html, */*; q=0.01',
				'X-Requested-With': 'XMLHttpRequest'
			}
		}).then(function(res) {
      fetch('/account/addresses', {
        method: 'GET'
      }).then(response=>response.text()).then(function(data) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, "text/html");
        const bodyEl = doc.body;
        const addressList = bodyEl.querySelector('#address-list');
        const newSlides = addressList.querySelectorAll('.address-block');
        const editForm = bodyEl.querySelector('#address-edit').innerHTML;
        addressSlider.removeAllSlides();
        newSlides.forEach(function(c,i){
          addressSlider.appendSlide(c);
        });
        $('#editFormContainer').empty().append(editForm);
        $('#edit-address').removeClass('visible');
        form.removeClass('disabled');
      }).catch(function(err) {
        console.error(err);
      });
		}).catch(function(err) {
			console.error(err);
		});
  });

  $(document).on('click','.delete-address',function(event){
    const el = $(this)[0];
    const JSONData = {
      _method: 'delete'
    };
    const form = $(this).parents('form');
    form.addClass('disabled');
    if (confirm(el.getAttribute('data-confirm-message'))) {
      fetch(el.dataset.target, {
        method: 'POST',
        body: getUrlString(JSONData),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          'Accept': 'text/html, */*; q=0.01',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(response=>response.text()).then(function(data) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, "text/html");
        const bodyEl = doc.body;
        const addressList = bodyEl.querySelector('#address-list');
        const newSlides = addressList.querySelectorAll('.address-block');
        const editForm = bodyEl.querySelector('#address-edit').innerHTML;
        addressSlider.removeAllSlides();
        newSlides.forEach(function(c,i){
          addressSlider.appendSlide(c);
        });
        $('#edit-address').removeClass('visible');
        $('#editFormContainer').empty().append(editForm);
        form.removeClass('disabled');
      }).catch(function(err) {
        console.error(err);
      });

    }

  })

  $(document).on('change','#order-filter',function(){
    const selectEl = $(this);
    selectEl.attr('disabled','disabled');
    const month = $(this).find(':selected').text();
    fetch('/account?view=orders', {
      method: 'GET'
    }).then(response=>response.text()).then(function(data) {
      const perPage = 5;
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, "text/html");
      const bodyEl = doc.body;
      const orderList = bodyEl.querySelector('#order-list');
      const selectedOrders = $(orderList).find(`[data-month="${month}"]`);
      $('.order-history tbody').empty();
      $('#order-pagination').empty();
      if(selectedOrders.length > 0){
        selectedOrders.each(function(){
          $('.order-history tbody').append($(this));
        });
        $(`.order-history tbody tr:nth-child(n+${perPage+1})`).addClass('hidden');
        const pages = Math.ceil(selectedOrders.length / perPage);
        $('#order-pagination').attr('data-total',pages);
        if(pages > 1){
          $('#order-pagination').append(`<li class="hidden">
                                        <a href="javascript:void(0)" aria-label="Previous page" class="prev-order-page">
                                          <svg aria-hidden="true" focusable="false" viewBox="0 0 10 6">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
                                          </path></svg>
                                        </a>
                                      </li>`);
          for(i=1;i<=pages;i++){
          if(i === 1){
            $('#order-pagination').append('<li><span aria-label="Page 1" data-page="1" class="current">1</span></li>');
          }else{
            $('#order-pagination').append(`<li><a href="javascript:void(0)" aria-label="Page ${i}" data-page="${i}">${i}</a></li>`);
          }
          }
          $('#order-pagination').append(`<li>
                                        <a href="javascript:void(0)" aria-label="Next page" class="next-order-page">
                                          <svg aria-hidden="true" focusable="false" viewBox="0 0 10 6">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
                                          </path></svg>
                                        </a>
                                      </li>`);
          }
      }else{
        $('.order-history tbody').append(`<tr><td colspan=4 style="text-align: center;padding: 10px 0;">No orders on ${month}</td></tr>`);
      }
      selectEl.removeAttr('disabled');
    }).catch(function(err) {
      console.error(err);
    });
  })

  $(document).on('click','.next-order-page', function(e){
    e.preventDefault();
    $(this).attr("disabled", "disabled");
    const perPage = 5;
    const currentPage = $('#order-pagination').find('span.current');
    const currentLi = currentPage.parent();
    const currentPageIndex = parseInt(currentPage.text());
    const nextIndexStart = parseInt(currentPage.text()) * perPage +1;
    const nextIndexEnd = (currentPageIndex + 1) * perPage;
    const nextPage = currentPage.parents('li').next();
    const total = parseInt($('#order-pagination').attr('data-total'));

    nextPage.empty();
    nextPage.append(`<span aria-current="page" class="current" aria-label="Page ${currentPageIndex + 1}" data-page="${currentPageIndex + 1}">${currentPageIndex + 1}</span>`);

    currentLi.empty();
    currentLi.append(`<a href="javascript:void(0)" aria-label="Page ${currentPageIndex}" data-page="${currentPageIndex}">${currentPageIndex}</a>`);

    $('#order-pagination .prev-order-page').parent().removeClass('hidden');
    $(this).removeAttr("disabled");

    $('.order-history tbody tr:not(.hidden)').addClass('hidden');
    for(i=nextIndexStart;i<=nextIndexEnd;i++){
      $(`.order-history tbody tr:nth-child(${i})`).removeClass('hidden');
    }

    if(currentPageIndex + 1 >= total){
      $(this).parents('li').addClass('hidden')
    }

  })

  $(document).on('click','.prev-order-page', function(e){
    e.preventDefault();
    $(this).attr("disabled", "disabled");
    const perPage = 5;
    const currentPage = $('#order-pagination').find('span.current');
    const currentLi = currentPage.parent();
    const currentPageIndex = parseInt(currentPage.text());

    const nextIndexStart = (currentPageIndex - 1) * perPage;
    const nextIndexEnd = (currentPageIndex - 2) * perPage + 1;

    const prevPage = currentPage.parents('li').prev();
    const total = parseInt($('#order-pagination').attr('data-total'));

    prevPage.empty();
    prevPage.append(`<span aria-current="page" class="current" aria-label="Page ${currentPageIndex - 1}" data-page="${currentPageIndex - 1}">${currentPageIndex - 1}</span>`);

    currentLi.empty();
    currentLi.append(`<a href="javascript:void(0)" aria-label="Page ${currentPageIndex}" data-page="${currentPageIndex}">${currentPageIndex}</a>`);

    $('#order-pagination .next-order-page').parent().removeClass('hidden');
    $(this).removeAttr("disabled");

    $('.order-history tbody tr:not(.hidden)').addClass('hidden');
    for(i=nextIndexStart;i>=nextIndexEnd;i--){
      $(`.order-history tbody tr:nth-child(${i})`).removeClass('hidden');
    }

    if(currentPageIndex - 1 <= 1){
      $(this).parents('li').addClass('hidden')
    }

  });

  $(document).on('click','.reorder-button',function(){
    $('.side-popup').removeClass('visible');
    $('#reorder-popup').addClass('visible');
    const order_title = $(this).next().find('h1').text();
    const order_cart = $(this).next().find('.reorder-cart').html();
    const order_cart_footer = $(this).next().find('.reorder-total').html();
    
    $('#reorder-popup').find('.reorder-contents > .popup-title').text(order_title);
    $('#reorder-popup').find('.reorder-contents > #reorder-cart').html(order_cart);
    $('#reorder-popup').find('.reorder-contents > #reorder-cart-footer').html(order_cart_footer);
  });

  $(document).on('click','.reorder-button-submit',function(){
    const item = [];
    $('#reorder-popup .form-key').each(function(){
      const key = {
        'id': parseInt($(this).attr('data-id')),
        'quantity': parseInt($(this).attr('data-qty'))
      }
      item.push(key);
    });
    const formData = {
      'items':item
    }
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then((response) => response.json())
    .then((response) => {
      if(response.status === 422){
        $('#reorder-form-error').text(response.description);
      }else{
        location.reload();
      }

    })
    .catch((error) => {
      $('#reorder-form-error').text(error.description);
    });


  })

  $(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();

    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top - 80
    }, 500);
  });


  

})
